/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 37
// module chunks = 0